import Vue from 'vue/dist/vue.esm'
import template from './slide_up_panel_template.slim'

Vue.component('slide-up-panel', {
  mixins: [template],
  props: {
    show_close_button: {
      type: Boolean,
      default: true
    },
    panelType: {
      type: String,
      default: ''
    },
    panelLabel: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false,
      showCloseButton: this.show_close_button,
      $rewriteNotesPopup: null,
      $rewriteNotesLoading: null,
      scrollPosition: 0
    }
  },
  methods: {
    hideRewritePopup() {
      this.$rewriteNotesPopup.hide();
      const editor = window.tinymce.activeEditor;
      if (editor) {
        editor.dom.setStyles(editor.dom.select("body"), { opacity: "1" });
        editor.mode.set("design");
      }
    },
    handleCloseClick() {
      if (this.isVisible) {
        this.$emit('close');
        this.hide();
      }
    },
    toggleVisible() {
      this.isVisible = !this.isVisible;
      this.$emit('panel-toggle', this.isVisible, this.panelType);
      
      if (this.isVisible) {
        this.scrollPosition = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
      } else {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this.scrollPosition);
      }
      
      if (this.$el.id === "objective-note" && this.$rewriteNotesPopup && this.$rewriteNotesLoading) {
        if (!this.$rewriteNotesLoading.is(":visible") || 
            (this.$rewriteNotesLoading.is(":visible") && !this.isVisible)) {
          this.$rewriteNotesPopup.fadeOut();
        }
      }
    },
    show() {
      if (!this.isVisible) {
        this.isVisible = true;
        this.$emit('panel-toggle', true, this.panelType);
        this.scrollPosition = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = '100%';
      }
    },
    hide() {
      if (this.isVisible && !this.$rewriteNotesLoading.is(":visible")) {
        this.isVisible = false;
        this.$emit('panel-toggle', false, this.panelType);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, this.scrollPosition);
        this.hideRewritePopup();
      }
    }
  },
  mounted() {
    this.$rewriteNotesPopup = $("#rewrite-notes-popup");
    this.$rewriteNotesLoading = $("#rewrite-notes-loading");
  },
  beforeDestroy() {
    if (this.isVisible) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, this.scrollPosition);
    }
  }
})
